const FormErrorMixin = {
    data() {
        return {
            errors: {},
        };
    },
    methods: {
        getError(error) {
            if (Array.isArray(error)) {
                error = error.map((error) => {
                    return this.getError(error);
                });
            } else {
                error = _.get(this.errors, error, []);
            }
            if (Array.isArray(error)) {
                return error.join(",");
            }
            return error;
        },
    },
};

export default FormErrorMixin;
